import { Directive, ElementRef, Renderer2, OnInit, OnDestroy, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img',
  standalone: false,
})
export class ImagePreloadDirective implements OnInit, OnDestroy {
  private readonly nativeEl: HTMLImageElement;
  private errorSubscription!: Subscription;

  private readonly el: ElementRef = inject(ElementRef);
  private readonly renderer: Renderer2 = inject(Renderer2);

  constructor() {
    this.nativeEl = this.el.nativeElement;
  }

  ngOnInit(): void {
    if ('loading' in HTMLImageElement.prototype) {
      this.renderer.setAttribute(this.nativeEl, 'loading', 'lazy');
    }
    this.errorSubscription = fromEvent(this.nativeEl, 'error').subscribe(() => this.replaceImage());
  }

  ngOnDestroy(): void {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
      this.errorSubscription = undefined!;
    }
  }

  /**
   * Both environment.defaultNoImg and environment.defaultImg are same image:
   * - environment.defaultNoImg - is from local assets
   * - environment.defaultImg   - is from digitalmedianp.shop.siemens-healthineers.com
   * Not refactored.
   * @private
   */
  private replaceImage(): void {
    const defaultSrc: string = this.nativeEl.getAttribute('data-default-src') || '';
    let src: string = defaultSrc || environment.defaultImg;
    if (this.nativeEl.src === environment.defaultImg) {
      src = environment.defaultNoImg;
    }
    this.renderer.setAttribute(this.nativeEl, 'src', src);
  }
}
